<template>
    <div id="app">
        <Header />
        <div class="sectionPageTitle">
            <div class="container conPaddingT conWidth">
                <h1 class="pageTitle">Get Your Free Proofreading and Editing Sample in {{ SelectedData.turnaround.textCapitalized }}</h1>
                <p v-if="holidayNow" class="holidayMesssageP">* ProofreadingPal has determined from {{ holiday.HolidayStartFriendly }} to {{ holiday.HolidayEndFriendly }} as a holiday period because of ({{ holiday.HolidayName }}). This sample order falls within or crosses over into a portion of our ({{ holiday.HolidayName }}) holiday period, so the turnaround speed will be 24-hour turnaround.</p>
            </div>
        </div>
        <section class="pageContent">
            <div class="container conPaddingS conWidth">
                <p class="pageSubtitle">Two proofreaders will proofread and edit your document. Your sample document will be kept confidential. Uploads and downloads to our server are securely encrypted.</p>
                <Loader v-if="isLoading" />
                <transition name="fade">
                    <CheckoutErrorMessages :errors="errors" v-if="errors && !isLoading" />
                </transition>
                <div
                    v-show="!isLoading"
                    
                >
                    <transition name="fade">
                        <router-view
                            @loaded="turnOffLoader"
                            :SelectedData="SelectedData"
                            :recaptchaDisable="recaptchaDisable"
                            @updateSampleData="updateSampleData($event)"
                            @moveToStep="moveToStep($event)"
                            @resendEmailCode="sendEmailValidation('resend')"
                        />
                    </transition>

                    <p v-if="holidayNow && stepActive=='step4'" class="holidayMesssageP">* ProofreadingPal has determined from {{ holiday.HolidayStartFriendly }} to {{ holiday.HolidayEndFriendly }} as a holiday period because of ({{ holiday.HolidayName }}). This sample order falls within or crosses over into a portion of our ({{ holiday.HolidayName }}) holiday period, so the turnaround speed will be 24-hour turnaround.</p>
                </div>
            </div>
        </section>
        <div class="alignCenter" style="font-size:12px;padding:15px 0;">
            © 2010 - {{ Currentyear }} ProofreadingPal LLC - All Rights
            Reserved.
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Header from '@/components/Header.vue'; // @ is an alias to /src
import Loader from '@/components/Loader.vue';
import Step1Validation from '@/components/Step1Validation.vue';
import Step2Validation from '@/components/Step2Validation.vue';
import Step3Validation from '@/components/Step3Validation.vue';
import CheckoutErrorMessages from '@/components/CheckoutErrorMessages.vue';

export default {
    mixins: [
        Step1Validation,
        Step2Validation,
        Step3Validation,
    ],
    components: {
        Header,
        Loader,
        CheckoutErrorMessages,
    },
    mounted: function() {
        // get all necessary checkout data
        this.checkHoliday();
    },
    data: function() {
        return {
            isLoading: false,
            recaptchaDisable: true,
            apiUniqueNumber: Math.ceil(Math.random()*1000000),
            holiday: false,
            holidayNow: false,
            SelectedData: {
                resent: false,
                turnaround: {
                    text: 'three to six hours',
                    textCapitalized: 'Three to Six Hours',
                    numbers: '3 to 6 hours',
                },
                finalTurnaround: '6 hours',
                verification: 'text',
                verification1: 'call',
                finalStatus: false,
                emailSent: false,
                sendingMail: false,
                recaptchaResponse: false,
                describeOption: '',
                englishType: '',
                fileUploaded: false,
                selectedWritingStyle: false,
                /*transactionId: 162738930010,
                fileUploaded: { 
                    name: '1626778860_1612sampe-coco.docx', 
                    url: '/php_uploads/2021/07/1626778860_1612sampe-coco.docx' 
                },
                selectedWritingStyle: { 
                    name: "apa", 
                    friendly: "American Psychological Association (APA)", 
                    description: "The APA style, which is set forth in the 7th edition of the APA manual, is commonly used to cite sources within the social sciences." 
                },*/
                /*firstName: "p",
                lastName: "p",
                email: "ivanob83@gmail.com",
                confirmEmail: "ivanob83@gmail.com",
                message: "das das",*/

            },
            movingStepsActive: false,
            steps: {
                step1: { completed: false },
                step1a: { completed: false },
                step2: { completed: false },
                step3: { completed: false },
                step4: { completed: false },
            },
            mailValidationSent: false,
            stepActive: 'step1',
            errors: false,
            Currentyear: new Date().getFullYear(), // for copyrights in footer
        };
    },
    watch: {
        $route(to) {
            this.routeName = to.name;
            this.isLoading = true;
        },
    },
    computed: {
    },
    methods: {
        updateSampleData(object) {
            for (const value in object) {
                this.SelectedData[value] = object[value];
            }
            this.SelectedData.email = this.SelectedData.email.trim();
        },
        turnOffLoader() {
            setTimeout(() => (this.isLoading = false), 500);
        },
        moveToStep(steps) {
            if(this.movingStepsActive) {
                return;
            }
            this.movingStepsActive = true;
            //const from = steps[0];
            let scroll = true;
            const to = steps[1];
            const from = steps[0];

            /*this.steps.step1.completed = true;
            this.steps.step1a.completed = true;
            this.steps.step2.completed = true;*/
            
            if(from == 0 && to == 2) {
                this.steps.step2.completed = false;
                this.processStep(to, scroll);
                return false;
            }
            if(from != 0) {
                if(!this.steps.step1.completed) {
                    if (!this.validateStep1()) {
                        this.movingStepsActive = false;
                        return false;
                    } else {
                        this.steps.step1.completed = true;
                        scroll = false;
                        this.SelectedData.sendingMail = true;
                        this.sendEmailValidation();
                        this.movingStepsActive = false;
                        return false;
                    }
                } 
                
                if(this.steps.step1.completed && !this.steps.step1a.completed) {
                    this.validateEmailCode().then(()=> {
                        if(!this.errors) {
                            this.steps.step1a.completed = true;
                            console.log(to);
                            this.processStep(to, scroll);
                        } else {
                            this.movingStepsActive = false;
                            return false; 
                        }
                        
                    });
                } else if(!this.steps.step2.completed && this.steps.step1a.completed) {
                    if(!this.validateStep2()) {
                        this.movingStepsActive = false;
                        return false;
                    } else {
                        this.sendTwilioRequest().then(()=> {
                            if(!this.errors) {
                                this.steps.step2.completed = true;
                                this.processStep(to, scroll);
                            } else {
                                this.movingStepsActive = false;
                                return false;
                            }
                        })
                    }
                } else if(!this.steps.step3.completed && this.steps.step2.completed) {
                    if(!this.validateStep3()) {
                        this.movingStepsActive = false;
                        return false;
                    } else {
                        this.checkTwilioCode().then(()=> {
                            if(!this.errors) {
                                this.steps.step3.completed = true;
                                this.processStep(to, scroll);
                            } else {
                                this.movingStepsActive = false;
                                return false; 
                            }
                        })
                    }
                }
            }

        },
        processStep(to, scroll) {
            if (to == 1) {
                this.stepActive = 'step1';
                if (this.$route.name != 'Step 1') {
                    this.$router.push({ name: 'Step 1' });
                }
            } else if (to == 2) {
                if(this.steps.step1.completed == true) {
                    this.stepActive = 'step2';
                    if (this.$route.name != 'Step 2') {
                        this.$router.push({ name: 'Step 2' });
                    }
                }
            } else if (to == 3) {
                if(this.steps.step2.completed == true) {
                    this.stepActive = 'step3';
                    if (this.$route.name != 'Step 3') {
                        this.$router.push({ name: 'Step 3' });
                    }
                }
            }  else if (to == 4) {
                if(this.steps.step3.completed == true) {
                    this.stepActive = 'step4';
                    if (this.$route.name != 'Step 4') {
                        this.$router.push({ name: 'Step 4' });
                    }
                }
            }
            if(scroll) {
                window.scrollTo(0, 0);
            }
            this.movingStepsActive = false;
        },
        checkHoliday() {
            axios
                .get(
                    this.siteUrl + 'checkout/API/CheckoutData.php?apiUnique='+this.apiUniqueNumber+'&check=Holiday'
                )
                .then(response => {
                    //console.log(response.data);
                    this.holiday = response.data.Holiday;
                    if(this.ifHolidayIsNow() || this.ifTurnaroundGoesInsideHoliday()) {
                        this.holidayNow = 'yes';
                    }
                });
        },
        ifTurnaroundGoesInsideHoliday() {
            const CurrentTime = parseInt(this.holiday.CurrentTime);
            const HolidayStart = parseInt(this.holiday.HolidayStart);
            const HolidayEnd = parseInt(this.holiday.HolidayEnd);
            const turnaroundLength = 6*60*60;
            if (this.ifHolidayIsNow()) {
                return true;
            } else if (
                CurrentTime + turnaroundLength > HolidayStart &&
                CurrentTime < HolidayEnd
            ) {
                return true;
            } else {
                return false;
            }
        },
        ifHolidayIsNow() {
            if (
                this.holiday.CurrentTime >= this.holiday.HolidayStart &&
                this.holiday.CurrentTime < this.holiday.HolidayEnd
            ) {
                return true;
            }
            return false;
        },
    }
};
</script>

<style lang="scss">
body input {
    font-size:16px; 
    font-family:Roboto, Arial, Helvetica, sans-serif;
    color: #414141;
}
// transition css
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.7s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
// /transition css
.onsaleCountdown {
    font-size: 22px;
    text-align: left;
    padding: 5px 15px;
    margin-top: 10px;
    color: #414141;
    font-weight: normal;
    background: #f5fae8;
    margin-bottom: 20px;
}
.formBlock{
    margin-bottom: 20px;
}
.formRow .button {
    margin-bottom: 10px;
}
.secureRight img {
    margin-left: 4px;
}
.holidayMesssageP {
	background: #F5F1EA;
	padding: 10px;
	margin-top: 5px;
	margin-bottom: 10px;
	border: 1px solid #E7DBC6;
}
</style>
